import { render, staticRenderFns } from "./ResourcesBar.vue?vue&type=template&id=765d0807&scoped=true&"
import script from "./ResourcesBar.vue?vue&type=script&lang=js&"
export * from "./ResourcesBar.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesBar.vue?vue&type=style&index=0&id=765d0807&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d0807",
  null
  
)

export default component.exports